import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { BookmarkPlus, X, Bookmark } from "lucide-react";

export const ReportTemplatesBar = ({ templates, onApply, onSave, onDelete }) => {
  const [name, setName] = useState("");
  const [open, setOpen] = useState(false);
  const save = async () => {
    if (!name.trim()) return;
    if (await onSave(name.trim())) { setName(""); setOpen(false); }
  };
  return (
    <div className="space-y-2" data-testid="report-templates-bar">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs font-semibold text-slate-600 mr-1">Hazır şablonlar:</span>
        {templates.length === 0 && <span className="text-xs text-slate-400" data-testid="report-templates-empty">Henüz şablon yok</span>}
        {templates.map((t) => (
          <span key={t.id} className="inline-flex items-center rounded-full border border-emerald-200 bg-white text-sm overflow-hidden" data-testid={`report-template-${t.id}`}>
            <button type="button" onClick={() => onApply(t)} title={t.created_by_name ? `Kaydeden: ${t.created_by_name}` : ""}
                    className="inline-flex items-center gap-1 pl-3 pr-2 py-1 text-emerald-800 hover:bg-emerald-50 transition-colors"
                    data-testid={`report-template-apply-${t.id}`}>
              <Bookmark className="h-3.5 w-3.5" /> {t.name}
            </button>
            <button type="button" onClick={() => onDelete(t)} aria-label="Şablonu sil"
                    className="px-2 py-1 text-slate-400 hover:text-rose-600 hover:bg-rose-50 transition-colors"
                    data-testid={`report-template-delete-${t.id}`}>
              <X className="h-3.5 w-3.5" />
            </button>
          </span>
        ))}
        {!open && (
          <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => setOpen(true)} data-testid="report-template-new-button">
            <BookmarkPlus className="h-3.5 w-3.5 mr-1" /> Seçimleri şablon olarak kaydet
          </Button>
        )}
      </div>
      {open && (
        <div className="flex flex-wrap items-center gap-2">
          <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} placeholder="Şablon adı, ör. Yıllık muhtar raporu"
                 className="h-8 w-64 bg-white" onKeyDown={(e) => { if (e.key === "Enter") save(); }} data-testid="report-template-name-input" />
          <Button type="button" size="sm" className="h-8 bg-emerald-700 hover:bg-emerald-800" onClick={save} data-testid="report-template-save-button">Kaydet</Button>
          <Button type="button" size="sm" variant="ghost" className="h-8" onClick={() => { setOpen(false); setName(""); }} data-testid="report-template-cancel-button">Vazgeç</Button>
        </div>
      )}
    </div>
  );
};
